import styled from "styled-components";

export const HorizontalSeparator = styled.span`
    width: 100%;
    border-top: solid 1px ${({ theme }) => theme.grayscale[50]};
`;
